<template>
  <div
    class="crl-link"
    @click="clickAction"
    v-bind:class="{ disabled: disabled }"
  >
    {{ caption }}
    <img class="crll-img" :src="EXTERNALICON" alt="externalicon" />
  </div>
</template>

<script>
import EXTERNALICON from "@/assets/icons/external.svg";

export default {
  name: "ExternalLink",
  props: {
    caption: { type: String },
    disabled: { type: Boolean },
  },
  data() {
    return {
      EXTERNALICON,
    };
  },
  methods: {
    clickAction() {
      this.$emit("clickLink");
    },
  },
};
</script>

<style scoped>
.crl-link {
  cursor: pointer;
  color: #29a9e2;
  display: flex;
  align-items: flex-start;
  width: 100%;
  white-space: pre-line;
}
.crll-img {
  margin-left: 8px;
  height: 16px;
  margin-top: 3px;
}
.disabled {
  pointer-events: none;
  cursor: default;
  color: #d8d9e0;
}
@media only screen and (min-width: 769px) {
  .crl-link br {
    white-space: normal;
  }
}
</style>
